import React from 'react'
import { FormControl, InputLabel, MenuItem, Select, type SelectChangeEvent } from '@mui/material'
import { Months, type Month } from 'helpers/monthHelper'

interface MonthSelectProps<T extends boolean> {
  value: T extends true ? Month | null : Month
  onChange: (month: T extends true ? Month | null : Month) => void
  disabled?: boolean
  label?: string
  showNone: T
  availableMonths?: Month[]
}

export const MonthSelect = <T extends boolean>({ value, onChange, disabled = false, label = 'Month', showNone, availableMonths }: MonthSelectProps<T>): JSX.Element => {
  const monthsToShow = availableMonths ?? Object.values(Months)

  const handleChange = (event: SelectChangeEvent<number>): void => {
    const selectedValue = event.target.value
    const month = Object.values(Months).find(m => m.number === selectedValue) ?? null
    onChange(month as (T extends true ? Month | null : Month))
  }

  return (
    <FormControl fullWidth variant="outlined">
      <InputLabel id="month-select-label">{label}</InputLabel>
      <Select
        labelId="month-select-label"
        id="month-select"
        value={value?.number ?? ''}
        label={label}
        onChange={handleChange}
        disabled={disabled}
      >
        {showNone && (
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
        )}
        {Object.values(monthsToShow).map((month) => (
          <MenuItem key={month.number} value={month.number}>
            {month.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
